const RETRY_WINDOW_MS = 60_000;
const RETRY_KEY = 'umasaura:asset-retry';

export function isLazyChunkFailure(error: unknown): boolean {
  const message = error && typeof error === 'object' && 'message' in error ? String(error.message) : String(error || '');
  return /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading chunk .+ failed|chunkloaderror/i.test(message);
}

export function shouldRetryLazyChunk(error: unknown, lastRetryAt: number, now: number): boolean {
  return isLazyChunkFailure(error) && (!lastRetryAt || now - lastRetryAt > RETRY_WINDOW_MS);
}

/** Reload once to replace an open tab's obsolete entry bundle. */
export function reloadOnceForAssetFailure(error?: unknown): boolean {
  try {
    const key = `${RETRY_KEY}:${window.location.pathname}`;
    const now = Date.now();
    const lastRetryAt = Number(window.sessionStorage.getItem(key) || 0);
    if (!shouldRetryLazyChunk(error ?? 'Failed to fetch dynamically imported module', lastRetryAt, now)) return false;
    window.sessionStorage.setItem(key, String(now));
    window.location.reload();
    return true;
  } catch {
    // Storage can be disabled. Keep the normal error screen instead of risking a reload loop.
    return false;
  }
}
